import ClipboardJS from 'clipboard';

export default class Clipboard {

  constructor() {
    let clipboardBtns = Array.from(document.querySelectorAll('.js-btn-clipboard')).map(c => new ClipboardJS(c));
  }

}
